import React, { useEffect, useState } from 'react';
import merchantLogo from '../media/Radiance-Logo.png';
import CCBadge from '../media/CC-Badge.svg';
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import MerchantImpactTicker from "./Ticker/MerchantImpact.js";
import * as impact from '../../common/api/impact';
import { projects as getProjects } from '../../common/api/projects'
import Accordian from '../../common/components/Accordian/Accordian.js'
import ProjectsScroll from "../../common/components/Projects/ProjectsScroll";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
  const [projects, setProjects] = useState();
  const [merchantImpact, setMerchantImpact] = useState();
  const [updatedTimeout, setUpdatedTimeout] = useState(null);


  useEffect(() => {
    setMerchantImpact(fetchedImpact);
  }, [fetchedImpact])

  useEffect(() => {
    getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

  }, []);

  const recurrentUpdateFetchedImpact = () => {
    return impact.merchants(merchantCode, null) // fetch updated impact
      .then(response => response.json())
      .then(body => {
        console.log(body)
        setUpdatedTimeout(setTimeout(recurrentUpdateFetchedImpact, 10000));
        setMerchantImpact(body)
      })
      .catch(error => {
        setUpdatedTimeout(setTimeout(recurrentUpdateFetchedImpact, 10000));
        console.error(error)
      })
      .finally()
  };

  useEffect(() => {
    if (merchantImpact && !updatedTimeout) {
      recurrentUpdateFetchedImpact();
      return () => clearInterval(updatedTimeout);
    }
  }, [merchantImpact]);

  return (
    <div className="App">
      <header className="w-100 position-relative hero-img bg-primary">
        <img style={{ top: '36px', right: '36px' }} className="position-absolute ccBadge" src={CCBadge} />
        <div className="container color-white text-left vertical-align">
          <div className="row">
            <div className="col-md-7">
              <div className="mb-2">
                <img style={{height: "60px"}} src={merchantLogo} />
              </div>
              <h1 className="mb-4 text-shadow">Radiance is Focused on Doing Better</h1>
              <div className="d-flex">
                <h5 className="mr-2 mt-1 font-bold">Climate Friendly by</h5>
                <div>
                  <img style={{ height: 30 }} src={logo} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="qualitySec" id="content">
        <div className="container text-center">
          <div className="mb-4 center mw-800px">
            <div className="center">
              <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                <g clipPath="url(#clip0)">
                  <path d="M68.2262 37.7569H58.9654L52.3517 30.4935C51.7223 29.8021 50.6641 29.7181 49.9335 30.3013L45.8306 33.5769L35.007 16.4803C34.6818 15.9667 34.1162 15.6553 33.5084 15.6553C32.9005 15.6553 32.3349 15.9667 32.0097 16.4803L22.7678 31.0786L19.3026 26.0078C18.9721 25.5242 18.424 25.2348 17.8381 25.2348C17.2521 25.2348 16.7042 25.5242 16.3735 26.0078L8.34462 37.7569H1.77377C0.794059 37.7569 0 38.5509 0 39.5307C0 40.5104 0.794059 41.3044 1.77377 41.3044H5.92026L4.50874 43.3697C3.95591 44.1785 4.16364 45.2822 4.97248 45.835C5.27855 46.0444 5.627 46.1445 5.9717 46.1445C6.53793 46.1445 7.09431 45.8739 7.43783 45.3713L8.12171 44.3705L17.8382 30.1525L20.7017 34.3428L14.3532 44.3707L9.76265 51.6219C9.2386 52.4496 9.48476 53.5452 10.3125 54.0693C10.607 54.2555 10.9351 54.3444 11.2597 54.3444C11.8472 54.3444 12.4223 54.0526 12.7599 53.5192L13.6029 52.1877L33.5086 20.7454L49.6804 46.2901L50.0843 46.9279C50.6081 47.7555 51.7039 48.0016 52.5317 47.4778C53.2849 47.0008 53.5546 46.0509 53.2022 45.26C53.1673 45.1819 53.1287 45.1046 53.0816 45.0303L47.7397 36.5925L50.848 34.111L61.5001 45.8098L62.7415 47.1733C63.0915 47.5578 63.5716 47.7529 64.0535 47.7529C64.4798 47.7529 64.9073 47.6001 65.2473 47.2907C65.9716 46.6311 66.0242 45.5093 65.3647 44.785L62.1956 41.3044H68.2264C69.2061 41.3044 70.0002 40.5104 70.0002 39.5307C70.0002 38.5509 69.2059 37.7569 68.2262 37.7569Z" fill="#A88F6E" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="70" height="70" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2 className="mt-0 font-bold color-primary">Our quality products are made with you, your family and our earth in mind.</h2>
            <h4 className="m-0">They say that good health comes from within and Radiance couldn’t agree more. We believe kiwis should have the most natural health formulas on the planet, that are better for the environment. We continue to offer our customers the same great formulas, but they now come in 100% reusable and recyclable aluminum packaging. But thats just the start.</h4>

          </div>
        </div>
      </section>
      <section className="d-flex">
        <img className="w-100" src={'https://res.cloudinary.com/carbonclick/image/upload/v1616545820/Enterprise/Radiance/mountain_fsjyww.png'} />
      </section>
      <section className="bg-grad impactSec">
        <div className="container center">
          <h3 className="font-bold mt-0">Our Positive Impact</h3>
          {
            merchantImpact?.carbonOffsetImpact ?
              <MerchantImpactTicker fetchedImpact={merchantImpact} />
              : (merchantImpact?.error ?
                <div style={{ textAlign: "center" }}>Could not load impacts, please try again later.</div>
                : <p>Loading Impact</p>)
          }
        </div>
      </section>

      <section className="color-secondary betterSec">
        <div className="container text-center">
          <h3 className="font-bold mt-0 ttl">It’s About Doing Things Better</h3>
          <div className="row">
            <div className="col-lg d-grid text-right pt-4 tab-text-center pr-md-1">
              <div className="mb-50px">
                <h5 className="color-primary font-bold">Transparent Label Policy</h5>
                <p>Radiance will always ensure all ingredients in the product are listed on the label so consumers have full transparency. We are committed to only having sustainably sourced ingredients. Where applicable, Radiance products have BIO Grow Certification.</p>
              </div>
              
              <div className="mb-50px">
                <h5 className="color-primary font-bold">Packing/Shipping Materials</h5>
                <p>In FY20, Radiance moved from plastic packaging to 100% recyclable aluminium packaging – already eliminating over 500,000 plastic bottles from even being manufactured. Radiance also changed all shipping materials over to sustainable/recyclable options such as paper and cardboard.</p>
              </div>
            </div>
            <div className="col-lg-auto d-grid img-cover info-img mb-3">
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <img src="https://res.cloudinary.com/carbonclick/image/upload/v1651816306/Enterprise/Radiance/info_tyunra_bm91m4.png" alt="It’s About Doing Things Better" />
              </div>
            </div>
            <div className="col-lg d-grid text-left pt-1 mb-3 tab-text-center pl-md-1">
            <div className="mb-50px">
                <h5 className="color-primary font-bold">Corporate Social Responsibility</h5>
                  <p><b>Green team:</b> we have a green team in the business who are working to ensure we are minimising our carbon footprint and to continually improve in this area.</p>
                  <p><b>Salvation Army:</b> our business has a monthly fundraiser internally to raise money for the Salvation Army.</p>
                  <p><b>City Mission:</b> we donate product to the City Mission.</p>
                  <p><b>Community days:</b> planned community days to get the team giving back.</p>
              </div>
              <div>
                <h5 className="color-primary font-bold">Carbon Offsetting Our Products</h5>
                <p>We have partnered with CarbonClick to offset 1kg of CO2 for every package we create. This will reduce the carbon footprint of each item by supporting amazing local and international renewable energy and reforestation projects.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
        <div className="projectSec">
        {projects?.length > 0 && <>
          <div className="container text-center">
            <div className="mb-5 center">
              <h3 className="color-primary font-bold">We Support Projects That Fight Climate Change</h3>
              <p>We support only the highest quality carbon offsetting projects around the <br/>world, to bring you peace of mind and results.</p>
            </div>
            <div className="text-left mobile-text-center">
              {fetchedImpact && fetchedImpact.projects ?
                <div>
                <ProjectsScroll projects={fetchedImpact.projects} /></div>
                : fetchedImpact && fetchedImpact.error ? 
                <div style={{ paddingTop: 20 }}><div>Could not load projects, please try again later.</div></div> 
                : null
              }
            </div> 
          </div>
          </>}
        </div>

      <section className="climateFriendly">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5">
              <div className="cfText">
                <h3>What makes Radiance Climate Friendly?</h3>
                <p>Radiance is all about doing things better and has partnered with CarbonClick to not only make great products that are good for you but that are also good for the Earth.</p>
                <p>Each of Radiance’s products are innovative, high potency natural health formulas, in recyclable packaging, providing you with an ethical and transparent product with a reduced carbon footprint.</p>
                <p>By purchasing any Radiance product, 1kg of carbon will be offset with CarbonClick.<br/>1kg of CO2 is like an average car driving for 4km, this may not seem like much but across our thousands of packages it really adds up!</p>
                <p>This 1kg from each Radiance product purchased offsets carbon footprint by supporting amazing local and international renewable energy and reforestation projects</p>
              </div>
            </div>
            <div className="col-lg-7 pr-lg-0">
              <div className="d-flex h-100"><img src="https://res.cloudinary.com/carbonclick/image/upload/v1652070829/Enterprise/Radiance/Learn_More_bmi0qe_1_ecjzka.png" alt="What makes Radiance Climate Friendly?" /></div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-tertiary py-5 landscapesSec">
        <div className="container">
            <div className="mw-800px center">
              <div className="row">
                <div className="col-6 p-3">
                  <img style={{ maxHeight: '540px', height: '100%', minHeight: '200px', width: 'auto' }} className="image" src="https://res.cloudinary.com/carbonclick/image/upload/v1616545820/Enterprise/Radiance/product_wy9for.png" />
                </div>
                <div className="col-6">
                  <div className="p-3 text-left">
                    <h4 style={{ fontSize: '32px' }} className="color-tertiary" >
                      Radiance celebrates New Zealand’s pure and natural landscapes with our unique design and recyclable and re-useable aluminium tins in rose gold, bringing Radiance to life.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </section>

      <section className="iframeSec">
        <div className="container-fluid px-0">
          <h3 className="text-center">Begin your climate action journey by better <br/>understanding your carbon footprint</h3>
          <iframe id="PersonalCalculator" className="calculator-iframe  d-flex flex-wrap" src={process.env.MY_CC_URL + '/personal-calculator-embed?merchantCode='+ merchantCode}></iframe>
        </div>
      </section>

      <section className="faqSec">
        <div className="container text-center">
          <h3 className="font-bold mt-0">Climate Friendly FAQs</h3>
          <div className="mb-3 center text-left mw-800px">
            <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
            <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
            <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
            <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
            <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>
          </div>
          <a href={footerLinks.faq} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg font-bold" >View All</a>
        </div>
      </section>

      <footer className="w-100 img-cover footer-img" >
        <div className="container color-white">
          <p className="pwdBy"><b>Powered by</b></p>
          <div className="d-flex" style={{ alignItems: "end" }}>
            <div>
              <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                <img style={{ height: 24 }} className="footer-logo mb-3" src={logo} alt="carbonclick" />
              </a>
            </div>
            <div className="right">
              <div>
                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                </a>
                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                </a>
                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                </a>
              </div>
            </div>
          </div>
          <hr className="sepFooter" />

          <div className="row">
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href="mailto:hello+radiance@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
